import {POSTER_PUSH_MODAL_IDS} from '@Components/poster-editor/components/post-poster-modal-spacer/post-poster-modal-spacer.types';

export const handlePasteOnPosterEditorCanvas = (e: ClipboardEvent): void => {
  const target = e.target as HTMLElement | null;
  const modalHashmap = window.PMW.redux.store.getState().modals.modalsHashmap;
  let isPosterPushModalOpened = false;

  for (const [modalId, modalData] of Object.entries(modalHashmap)) {
    if (modalData.isOpen && !POSTER_PUSH_MODAL_IDS[modalId] && modalData.panelProps?.hideOnClose !== true) {
      isPosterPushModalOpened = true;
    }
  }

  const isEditable = target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target?.isContentEditable;
  if (isPosterPushModalOpened || isEditable) {
    return;
  }

  void window.posterEditor?.whiteboard?.getCurrentPage().clipboard.pasteItems(e);
};
